import { render, staticRenderFns } from "./TextField.vue?vue&type=template&id=0d60fc40"
import script from "./TextField.ts?vue&type=script&lang=ts&external"
export * from "./TextField.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports